export default {
  th: {},
  en: {},
};
